<template>
  <div/>
</template>

<script>

// Exists only for consistency with other subscription states
export default {
  name: 'OnboardingSettings',
};
</script>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/account-settings/OnboardingSettings.vue